<template>
  <div class="footer d-flex flex-column flex-sm-row fs-6 fw-bold w-100 m-0 p-0 overflow-hidden">
    <!-- Copyright -->
    <div class="text-center py-2 w-100" style="background-color: #04C8C8;">
      <span style="letter-spacing: 2px;"><strong>&copy; HAKCIPTA JABATAN AKAUNTAN NEGARA MALAYSIA 2022</strong></span>
      <br>
      <span style="font-size: 12px;">(Paparan terbaik dengan pelayar Firefox atau Chrome pada resolusi 1366 x 768 ke atas)</span>
    </div>
    <!--end::Copyright-->

    <!--begin::Links-->
    <!-- <div class="flex-grow-1 py-5">
      <router-link
        :to="{
          name: 'privacy-policy',
        }"
      >
        Dasar Privasi
      </router-link>
      <a href="#" class="border-start px-2">Terma &amp; Syarat</a>
      <a href="#" class="border-start px-2">Hubungi Kami</a>
    </div> -->
    <!--end::Links-->

    <div class="fixed-bottom p-3 fs-8">
      {{ app_version }}
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "custom-layout-footer",
  props: {},
  components: {},
  data() {
    return {
      app_version: process.env.VUE_APP_VERSION,
    };
  },
});
</script>

<style></style>
